/* istanbul ignore file */
import { ListFilterLayout as FiltersLayout, StaticFilters as Filters, MonthFilter } from 'framework/list';

import React from 'react';
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { MAX_SM_WIDTH } from 'framework/utils';
import PerformPayrollDistributionButton from 'domain/finance/payroll/payrollDistribution/shared/button/PerformPayrollDistributionButton';
import PerformSandboxDistributionButton from '../shared/button/PerformSandboxDistributionButton';

const PayrollDistributionStaticFilters = ({ title, sx = {} }: { title?: React.ReactNode; sx?: SxProps<Theme> }) => {
  const filters = (
    <Filters>
      <FiltersLayout>
        <MonthFilter label="" source="period" isRequired hasTodayButton todayButtonLabel="Current month" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <Box
      sx={{
        [`@media (min-width: ${MAX_SM_WIDTH}px)`]: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        '& [data-testId="remove-btn"], & .filters-reset-btn': {
          display: 'none',
        },
        '.filter-item-wrapper': {
          marginRight: 0,
          marginBottom: 0,
        },
        '@media (min-width: 768px)': {
          '.rdtPicker': {
            right: 0,
          },
        },
        ...sx,
      }}
    >
      {title}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          button: {
            mr: 2,
            mb: '20px',
          },
        }}
      >
        <PerformPayrollDistributionButton />
        <PerformSandboxDistributionButton />
        {filters}
      </Box>
    </Box>
  );
};

export default PayrollDistributionStaticFilters;
